<template>
    <div id="app">
        <v-app id="inspire">
            <v-card-title>
                <span class="headline">{{ formTitle }}</span>
            </v-card-title>
            <v-container grid-list-xl>
                <v-form
                ref="form"
                v-model="valid"
                lazy-validation>
                    <v-layout
                        v-if="this.editedIndex === -1"
                        class="mt-3"
                        row
                        align-end
                        justify-space-between
                    >
                        <v-flex xs12 sm12 md5>
                            <v-text-field type="file" @change="onChange" label="Selecione o arquivo" :rules="obgRules" required></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm12 md5>
                            <v-text-field v-model="newCertificado.pass" label="Senha do Certificado Digital" counter="25" :rules="tamanhoRules" required></v-text-field>
                        </v-flex>
                    </v-layout>
                    <v-layout
                        class="mt-3"
                        row
                        align-end
                        justify-space-between
                    >
                        <v-flex xs12 sm12 md5>
                            <v-combobox
                                v-model="newCertificado.empresas"
                                :items="tipoEmpresas"
                                label="Empresas"
                                hide-no-data
                                 deletable-chips
                                hide-selected
                                item-text="nome"
                                item-value="id"
                                placeholder="Comece a digitar para procurar"
                                :loading="loadingEmpresas"
                                :search-input.sync="searchEmpresa"
                                multiple
                                chips
                                :rules="obgRules"
                                required
                            >
                            </v-combobox>
                        </v-flex>
                        <v-flex xs12 sm12 md5
                            v-if="this.editedIndex === 1">
                            <v-text-field v-model="cnpj" label="CNPJ" readonly></v-text-field>
                        </v-flex>
                    </v-layout>
                    <v-layout
                        v-if="this.editedIndex === 1"
                        row
                        justify-space-between
                    >
                        <v-flex xs12 sm12 md5>
                            <v-text-field v-model="data_validade" label="Data de Validade" readonly></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm12 md5>
                            <v-textarea v-model="descricao"
                                rows="1"
                                label="Descrição"
                                readonly
                            ></v-textarea>
                        </v-flex>
                    </v-layout>
                </v-form>
                <v-layout
                    class="mt-4"
                    row
                    align-end
                >
                    <v-btn
                    class="ml-2"
                    color="success"
                    @click="criarCertificado"
                    >
                    Salvar
                    </v-btn>

                    <v-btn
                    v-if="this.editedIndex === -1"
                    color="error"
                    @click="reset"
                    >
                    Cancelar
                    </v-btn>

                    <v-btn
                    color="warning"
                    @click="back"
                    >
                    Voltar
                    </v-btn>
                </v-layout>
                <v-layout
                    class="mt-4">
                    <v-flex xs12 md12>
                        <v-textarea
                            v-if="this.envio !== ''"
                            disabled
                            outline
                            no-resize
                            rows = "5"
                            name="inputEnvio"
                            label="Envio"
                            :value="this.envio"
                        ></v-textarea>
                    </v-flex>
                </v-layout>
                <v-layout>
                    <v-flex xs12 md12>
                        <v-textarea
                            v-if="this.mostrar !== ''"
                            disabled
                            outline
                            no-resize
                            color="purple"
                            rows = "5"
                            name="inputMostrar"
                            label="Resposta"
                            :value="this.mostrar"
                        ></v-textarea>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-app>
    </div>
</template>

<script>
    import {sharedService} from '../services'


    export default {
        name: 'CertificadosForm',
        data() {
            return {
                loadingEmpresas: false,
                searchEmpresa: '',
                tipoEmpresas: [],
                mostrar: '',
                envio: '',
                editedIndex: -1,
                newCertificado:{
                   pass: '',
                   conteudo: '',
                   empresas: ''
                },
                cnpj: '',
                data_validade:'',
                descricao: '',
                valid: true,
                text: '',
                obgRules: [
                    v => !!v || 'Este campo é obrigatório',
                ],
                tamanhoRules: [
                    v => !!v || 'Este campo é obrigatório',
                    v => v.length <= 25 || 'Máximo 25 caracteres'
                ]
            }
        },
        created () {
            if (this.$route.params.id) {
                this.id = this.$route.params.id
                this.editedIndex = 1
                this.getData()
            } else {
                this.editedIndex = -1
            }
        },
        computed: {
            formTitle () {
                return this.editedIndex === -1 ? 'Novo Certificado' : 'Edita Certificado'
            }
        },
        methods: {
            onChange(){
                let self = this

                var file = document.querySelector('input[type=file]').files[0];

                let reader = new FileReader()

                reader.readAsDataURL(file)

                reader.onload = () => {
                    let resultado = reader.result
                    self.newCertificado.conteudo = resultado.substring(33)
                }

            },
            criarCertificado() {
                let self = this
                if(this.editedIndex === -1){
                    this.$confirm('Tem certeza que deseja salvar este item?').then(res => {
                        if (res) {
                            if (this.$refs.form.validate()) {
                                if(self.newCertificado.conteudo !== ''){
                                    sharedService.create('Certificados', this.newCertificado).then(function (obj){
                                        self.envio = JSON.stringify(self.newCertificado)
                                         obj.text().then(function (text){
                                            self.mostrar = text
                                            if(obj.status === 200){
                                                self.$store.dispatch('success', 'Certificado cadastrado com sucesso!')
                                            }  else {
                                                self.$store.dispatch('error', text)
                                            }
                                        })
                                    })
                                } else {
                                    alert('Insira o certificado digital!')
                                }
                            } else {
                                alert('Preencha os campos obrigatórios!')
                            }
                        } else {
                            this.close()
                        }
                    })
                } else{
                    this.$confirm('Tem certeza que deseja editar este item?').then(res => {
                        if (res) {
                            if (this.$refs.form.validate()) {
                                sharedService.update('Certificados', this.newCertificado, this.id).then(function (obj){
                                    self.envio = JSON.stringify(self.newCertificado)
                                    obj.text().then(function (text){
                                        self.mostrar = text

                                        if(obj.status === 200){
                                            self.$store.dispatch('success', 'Certificado editado com sucesso!')
                                        }  else {
                                            self.$store.dispatch('error', text)
                                        }
                                    })
                                })
                            } else {
                                alert('Preencha os campos obrigatórios!')
                            }
                        } else {
                            this.close()
                        }
                    })
                }
            },
            back () {
                this.$router.push({
                    name: 'Certificados'
                })
            },
            reset () {
                this.$refs.form.reset()
            },
            getData: async function () {
                let self = this
                await sharedService.read('Certificados',{limit: 1}, this.id).then(function (obj){
                    self.newCertificado.pass = obj.pass
                    self.newCertificado.empresas = obj.empresas
                    self.newCertificado.conteudo = obj.conteudo
                    self.cnpj = obj.cnpj
                    self.descricao = obj.descricao
                    self.data_validade = obj.data_validade
                })
            }
        }, 
        watch: {
            searchEmpresa (val) {
                let self = this

                let busca
                if(val === null || val === ''){
                    busca = 'limit=10'
                } else {
                    busca = 'filtros=[["nome_fantasia","like","'+val+'%"]]'
                }

                sharedService.read('Empresas?'+busca).then(function (obj){
                    self.tipoEmpresas = []
                    for (var key in obj.obj) {
                        let obje = {
                            id: obj.obj[key].id,
                            nome: obj.obj[key].nome_fantasia
                        }
                        self.tipoEmpresas.push(obje)
                    }
                })
            }
        }
    }
</script>

<style scoped>

</style>
